import React from 'react';

// Inline SVG icons for the Foundation Lesson — stroke #A8003F,
// strokeWidth 1.6, round caps/joins. Render at 20x20 inside a 32x32
// pale-rose disc on bullet cards / note cards.

export const ICON_STROKE = '#A8003F';

function SvgIcon({ children }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {children}
    </svg>
  );
}

// person (body awareness)
export const IconPerson = () => (
  <SvgIcon>
    <circle cx="12" cy="6" r="3" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 21c0-4 3-7 7-7s7 3 7 7" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

// wind / breath
export const IconWind = () => (
  <SvgIcon>
    <path d="M3 8h11a3 3 0 1 0-3-3" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 14h15a3 3 0 1 1-3 3" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 20h9" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

// grip / squeeze (hand-like)
export const IconSqueeze = () => (
  <SvgIcon>
    <path d="M8 5v6" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 5v6" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 11c0 2 1.5 3 4 3s4-1 4-3" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 14v5" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 14v5" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

// wave / relax
export const IconRelax = () => (
  <SvgIcon>
    <path d="M3 8c2-2 4-2 6 0s4 2 6 0 4-2 6 0" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 14c2-2 4-2 6 0s4 2 6 0 4-2 6 0" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

// arrow-out / push
export const IconPush = () => (
  <SvgIcon>
    <path d="M12 5v14" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 13l6 6 6-6" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

// hexagon / pelvis
export const IconPelvis = () => (
  <SvgIcon>
    <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

// Three parallel diagonal strokes, layered slightly offset: reads as
// "muscle fibres lengthening". Used on the Gentle Push "Why it matters"
// card where the copy is about eccentric contractions + fibre control.
export const IconFibre = () => (
  <SvgIcon>
    <path d="M5 16l7-9" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" />
    <path d="M9 17l7-9" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" opacity="0.75" />
    <path d="M13 18l7-9" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" opacity="0.5" />
  </SvgIcon>
);

// spark / lightbulb — insight/tip
export const IconSpark = () => (
  <SvgIcon>
    <path d="M12 3v3" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 18v3" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 12h3" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 12h3" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="3" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

// drop — bath / water
export const IconDrop = () => (
  <SvgIcon>
    <path d="M12 3s6 7 6 12a6 6 0 1 1-12 0c0-5 6-12 6-12z" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

// shield — safety
export const IconShield = () => (
  <SvgIcon>
    <path d="M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6l7-3z" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 12l2 2 4-4" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

// check — correct / done
export const IconCheck = () => (
  <SvgIcon>
    <path d="M5 12l5 5L20 7" stroke={ICON_STROKE} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);
